import {Serializer} from '~/app/core/common/serializers/serializer';
import {OrderReviewItem} from '~/app/core/common/models/OrderReviewItem';

export class OrderReviewItemSerializer implements Serializer {
    fromJson(json: any): OrderReviewItem {
        const item = {} as OrderReviewItem;
        item.itemNo = json.itemNo;
        item.critical = json.critical;
        item.maxQuantity = json.maxQuantity;
        item.minQuantity = json.minQuantity;
        item.daysSinceLast = json.daysSinceLast;
        item.unitOfMeasure = json.unitOfMeasure;
        item.showIndicator = json.showIndicator;
        item.categoryIndex = json.categoryIndex;
        item.custMax = json.custMax;
        item.description = json.description;
        item.sequence = json.sequence;
        item.qtyLastOrdered = json.qtyLastOrdered;
        item.restriction = json.restriction;
        item.perCost = json.perCost;
        item.quantity = json.quantity;
        item.price = json.price;
        item.totalCost = json.totalCost;
        return item;
    }

    toJson(resource: OrderReviewItem) {
        const item = {} as OrderReviewItem;
        item.itemNo = resource.itemNo;
        item.critical = resource.critical;
        item.maxQuantity = resource.maxQuantity;
        item.minQuantity = resource.minQuantity;
        item.daysSinceLast = resource.daysSinceLast;
        item.unitOfMeasure = resource.unitOfMeasure;
        item.showIndicator = resource.showIndicator;
        item.categoryIndex = resource.categoryIndex;
        item.custMax = resource.custMax;
        item.description = resource.description;
        item.sequence = resource.sequence;
        item.qtyLastOrdered = resource.qtyLastOrdered;
        item.restriction = resource.restriction;
        item.perCost = resource.perCost;
        item.quantity = resource.quantity;
        item.price = resource.price;
        item.totalCost = resource.totalCost;
        item.totalCost = resource.totalCost;
        return JSON.stringify(item);
    }

}
